// @ts-ignore - no types available for 'posthog-js'
import posthog from "posthog-js";

// TODO: When voter file enrichment lands (PRD 01), add data-ph-mask attributes
// to components that display voter PII (contact detail, people table, enrichment
// section). The maskTextSelector below is already configured to respect it.
// Key components to update:
//   - components/contacts/contact-info-section.tsx
//   - components/contacts/contact-enrichment-section.tsx
//   - components/contacts/people-table.tsx
//   - components/contacts/pipeline-card.tsx

let initialized = false;

export function initPostHog() {
	const key = import.meta.env.VITE_POSTHOG_KEY;
	const host = import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com";

	if (!key || initialized) return;

	posthog.init(key, {
		api_host: host,
		autocapture: true,
		capture_pageview: false,
		capture_pageleave: true,
		session_recording: {
			maskAllInputs: true,
			maskTextSelector: "[data-ph-mask]",
		},
		enable_recording_console_log: true,
		capture_exceptions: true,
	});

	// Tag every event with the build environment (production | development)
	posthog.register({ environment: import.meta.env.MODE });

	initialized = true;
}

export { posthog };
